import { useState, useEffect } from 'react';

const useLoading = (initialDelay = 1000) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, initialDelay);

        return () => clearTimeout(timer);
    }, [initialDelay]);

    return isLoading;
};

export default useLoading; 